/**
 * Input Types
 *
 * @typedef {Object} TaxClassInput
 * @property {string} id
 * @property {string} name
 * @property {string} type
 * @property {string[]} taxRules - Array of taxRule IDs
 *
 * @typedef {Object} TaxRuleInput
 * @property {string} id
 * @property {string} name
 * @property {number} rate
 * @property {string} revenueCode
 * @property {boolean} displayRevenueCode
 *
 * Output Types
 *
 * @typedef {Object} TaxClassOutput
 * @property {string} id
 * @property {string} name
 * @property {string} type
 * @property {string[]} taxRules
 *
 * @typedef {Object} TaxRuleOutput
 * @property {string} name
 * @property {number} rate
 * @property {string} revenueCode
 * @property {boolean} displayRevenueCode
 *
 * @typedef {Object} TaxesOutput
 * @property {Object.<string, TaxClassOutput>} taxClasses - Map of taxClass ID to TaxClassOutput
 * @property {Object.<string, TaxRuleOutput>} taxRules - Map of taxRule ID to TaxRuleOutput
 */

export const mapTaxes = (taxes) => {
  const taxClasses = {}
  const taxRules = {}

  taxes.taxClasses?.forEach((taxClass) => {
    taxClasses[taxClass.id] = {
      id: taxClass.id,
      name: taxClass.name,
      type: taxClass.type,
      taxRules: removeDuplicateTaxRules(taxClass.taxRules),
    }
  })

  taxes.taxRules?.forEach((taxRule) => {
    taxRules[taxRule.id] = {
      //mapping as display name to match totals and order details requests
      displayName: taxRule.name,
      rate: taxRule.rate,
      revenueCode: taxRule.revenueCode,
      displayRevenueCode: taxRule.displayRevenueCode,
    }
  })

  return {
    taxClasses,
    taxRules,
  }
}

const removeDuplicateTaxRules = (taxRules) => {
  return [...new Set(taxRules)]
}
